@if (msg) {
  <div class="alert alert-success">{{ msg }}</div>
}
@if (error_msg) {
  <div class="alert alert-danger">{{ error_msg }}</div>
}

<div class="card bg-light">
  <div class="card-header">
    <h3>Send message to all users</h3>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="mailing_list" class="col-form-label">Mailing list</label>
          <select id="mailing_list" placeholder="Choose your mailing list" [ngModelOptions]="{ standalone: true }" [(ngModel)]="mailing_list" (change)="decode_template($event); generate_list_members($event)" class="form-control">
            <option value="" disabled selected>Select your mailing list</option>
            @for (list of mailing_lists; track list) {
              <option [value]="list.list_name">{{ list.list_name }}</option>
            }
          </select>
          @if (mailing_list) {
            <br />
          }
          @if (mailing_list) {
            <p-button type="button" size="small" severity="primary" data-bs-toggle="modal" data-bs-target="#members_view" label="View list members"></p-button>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label for="input_type" class="col-form-label">Input type</label>
          <select id="input_type" (change)="decode_template($event.target.value)" [ngModelOptions]="{ standalone: true }" [(ngModel)]="input_type" class="form-control">
            @for (input of input_choices; track input) {
              <option [value]="input">{{ input }}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="from" class="col-form-label">From</label>
          <input class="form-control" id="from" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="origin" class="form-control" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="subject" class="col-form-label">Subject</label>
          <input class="form-control" placeholder="Subject" id="subject" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="subject" class="form-control" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="message" class="col-form-label">Message</label>
          <textarea class="form-control" placeholder="Type your message" [ngModelOptions]="{ standalone: true }" [(ngModel)]="message" rows="20" cols="100" class="form-control"></textarea>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    @if (message && subject && (input_type == 'HTML' || input_type == 'Markdown')) {
      <p-button type="button" size="small" severity="primary" styleClass="pull-right" data-bs-toggle="modal" data-bs-target="#HTML_viewer" label="Viewer"></p-button>
    }

    @if (mailing_lists && mailing_lists.length > 0) {
      <p-button type="button" size="small" severity="secondary" (onClick)="send()" label="Send"></p-button>
    }
    <div class="row">
      @if (msg) {
        <div class="alert alert-success">{{ msg }}</div>
      }
      @if (error_msg) {
        <div class="alert alert-danger">{{ error_msg }}</div>
      }
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal" style="z-index: 1500" id="HTML_viewer" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        @if (input_type == 'HTML') {
          <p [innerHTML]="trustAsHtml(message)"></p>
        }
        @if (input_type == 'Markdown') {
          <p [innerHTML]="trustAsMarkdown(message)"></p>
        }
      </div>
      <div class="modal-footer">
        <p-button type="button" size="small" severity="secondary" data-bs-dismiss="modal" label="Close"></p-button>
      </div>
    </div>
  </div>
</div>

<div class="modal" style="z-index: 1500" id="members_view" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="list-members">
          <div class="table-responsive table-striped">
            <p-table #dtp [value]="members" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]">
              <ng-template pTemplate="header">
                <tr>
                  <th>Email</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-member>
                <tr>
                  <td>{{ member }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <p-button type="button" size="small" severity="secondary" data-bs-dismiss="modal" label="Close"></p-button>
      </div>
    </div>
  </div>
</div>
